import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const MAIN_SITE_URL = 'https://thehideoutcommunity.com';
export default class SiteLogoutPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.started = false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Logging Out');
    app.setTitleCount(0);
    this.logout();
  }
  logout() {
    if (this.started) {
      return;
    }
    this.started = true;
    if (!app.session.user) {
      window.location.replace(MAIN_SITE_URL);
      return;
    }
    app.session.logout().then(() => {
      window.location.replace(MAIN_SITE_URL);
    }).catch(error => {
      console.error('Flarum logout response:', error);

      /*
       * Some Flarum versions reload after logout instead
       * of resolving the promise. Returning to the page
       * verifies the session and finishes the redirect.
       */
      window.location.replace(`${app.forum.attribute('baseUrl')}/hideout/site-logout`);
    });
  }
  view() {
    return m(PageStructure, {
      className: "HideoutSiteLoginPage"
    }, m("div", {
      className: "HideoutSiteLoginContainer"
    }, m("section", {
      className: "HideoutSiteLoginPanel"
    }, m(LoadingIndicator, null), m("h1", null, "Logging out"), m("p", null, "Closing your Hideout website and forum sessions..."))));
  }
}
flarum.reg.add('thehideout-core', 'forum/components/SiteLogoutPage', SiteLogoutPage);